
import { defineComponent } from "vue";
import CustomerDetailsView from "@/views/CustomerDetailsView.vue";

export default defineComponent({
  components: {
    CustomerDetailsView,
  },
  async setup() {
    return {};
  },
});
